// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Yntz","productName":"Table_productName__2TnGl"};